<template>
  <div class="player-container">
    <el-row>
      <el-col :span="8" style="margin-left: 10px;">
        <span>起止日期</span>
        <el-date-picker
          v-model="search.begin"
          type="date"
          placeholder="选择日期">
        </el-date-picker>
        <span>至</span>
        <el-date-picker
          v-model="search.end"
          type="date"
          placeholder="选择日期">
        </el-date-picker>
        <el-button @click="quickSearch">查询</el-button>
      </el-col>
    </el-row>
    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%">
      <el-table-column
        prop="type"
        width="100">
        <template slot="header" slot-scope="scope">
          <div>比赛类型</div>
        </template>
        <template slot-scope="scope">
          <bjh-link :to="getMatchTypeListRouter(scope.row)">{{formatType(scope.row.type)}}</bjh-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="type0"
        label="主裁"
        align="center">
      </el-table-column>
      <el-table-column
        prop="type1"
        label="边裁"
        align="center">
      </el-table-column>
      <el-table-column
        prop="type3"
        label="计时"
        align="center">
      </el-table-column>
      <el-table-column
        prop="type4"
        label="记录"
        align="center">
      </el-table-column>
      <el-table-column
        prop="type5"
        label="宣告"
        align="center">
      </el-table-column>
      <el-table-column
        prop="type6"
        label="记罚"
        align="center">
      </el-table-column>
      <el-table-column
        prop="type7"
        label="助理"
        align="center">
      </el-table-column>
      <el-table-column
        prop="type2"
        label="裁判监督"
        align="center">
      </el-table-column>
      <el-table-column
        prop="type8"
        label="比赛监督"
        align="center">
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination
        v-show="totalCount>0"
        @size-change="handleSizeChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>

import * as moment from 'moment'
import permission from '@/directive/permission/index.js' // 权限判断指令
import checkPermission from '@/utils/permission' // 权限判断函数
import { AdminGetRefereeMatchTypeList } from '@/api/referee'

const defaultForm = {}

export default {
  name: 'RefereeGameList',
  directives: { permission },
  data() {
    return {
      search: {},
      list: [],
      totalCount: 0, // 默认数据总数
      pageSize: 10, // 每页的数据条数
      currentPage: 1, // 默认开始页面
      listQuery: {},
      listLoading: true,
      routerParams: {},
      types:["标准比赛","小场地","国际","国家","市级","地区"],
      typeCount:{}
    }
  },
  created() {
    this.routerParams = {
      id: this.$route.params.refereeId,
      userId: this.$route.params.uId
    }
    this.search.matchName = this.$route.query && this.$route.query.matchName
    this.getList()
  },
  methods: {
    checkPermission,
    getMatchTypeListRouter(row){
      return {path: `/league/league-referee-game-list/${this.routerParams.id}/${this.routerParams.userId}?matchType=${row.type}`}
    },
    exportData(){
      this.$message({
        message: '开发中...',
        type: 'warning'
      })
    },
    getMatchRefereeStatsRouter(row) {
      return {path: `/league/${row.matchId}/referees`}
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.$router.push({path: this.$route.path, query: {page: val}})
      this.currentPage = val
      this.getList()
    },
    quickSearch() {
      this.getList()
    },
    getList() {
      this.listLoading = true
      this.listQuery = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        refereeId: this.routerParams.id
      }
      if (this.search.createDate) {
        this.search.createDate = moment(this.search.createDate).format('YYYY-MM-DD')
      }
      this.listQuery = Object.assign(this.listQuery, this.search)
      AdminGetRefereeMatchTypeList(this.listQuery).then(response => {
        const data = response.data;
        this.list = data.list
        this.currentPage = data.pageNum
        this.totalCount = data.count
        this.listLoading = false
        this.typeCount = data.types
      })
    },
    formatDate: function(row, column) {
      const date = row[column.property]
      return date && moment(date).format('YYYY-MM-DD HH:mm')
    },
    formatType: function (t) {
      if(t >= 0 && t <= 8)
        return this.types[t]
      else
        return "-"
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .player-container {
    margin: 30px 15px;
    .action-header {
      padding: 0 10px 10px 10px;
    }
    .el-table {
      th {
        div {
          line-height: 20px;
        }
        .el-select {
          padding-left: 0;
          padding-right: 0;
          .el-input {
            padding-left: 0;
            padding-right: 0;
          }
        }
      }
      th>{
        .cell {
          text-overflow: clip;
        }
      }
    }

    .table-footer {
      text-align: center;
      margin-top: 30px;
    }
  }
  .type-count {
    text-align: center;
  }
</style>
